import instance from 'utils/axios/instance.axios';
import { REVIEWS } from './_constant';

export const getReviewsDetail = (councilMemberId, projectProposalId, councilId) =>
  instance.get(REVIEWS.GET_REVIEWS_DETAIL, {
    params: {
      councilMemberId,
      projectProposalId,
      councilId,
    },
  });

export const getReviewerInfo = (projectProposalId, councilId) =>
  instance.get(REVIEWS.GET_REVIEWER_INFO, {
    params: {
      projectProposalId,
      councilId,
    },
  });

export const createReviews = (body = {}) => instance.post(REVIEWS.CREATE_REVIEW, body);

export const updateReviews = (body = {}) => instance.patch(REVIEWS.UPDATE_REVIEW, body);

export const submitReviews = (body = {}) => instance.patch(REVIEWS.SUBMIT_REVIEW, body);

export const downloadDocxFile = ({ councilMemberId, projectProposalId, councilId }) =>
  instance.get(REVIEWS.DOWNLOAD_DOCX_FILE, {
    params: {
      councilMemberId,
      projectProposalId,
      councilId,
    },
    responseType: 'blob',
  });

export const downloadDocxTemplate = ({ councilMemberId, projectProposalId, councilId }) =>
  instance.get(REVIEWS.DOWNLOAD_DOCX_TEMPLATE, {
    params: {
      councilMemberId,
      projectProposalId,
      councilId,
    },
    responseType: 'blob',
  });

export const downloadPdfFile = ({ councilMemberId, projectProposalId, councilId }) =>
  instance.get(REVIEWS.DOWNLOAD_PDF_FILE, {
    params: {
      councilMemberId,
      projectProposalId,
      councilId,
    },
    responseType: 'blob',
  });

export const downloadPdfTemplate = ({ councilMemberId, projectProposalId, councilId }) =>
  instance.get(REVIEWS.DOWNLOAD_PDF_TEMPLATE, {
    params: {
      councilMemberId,
      projectProposalId,
      councilId,
    },
    responseType: 'blob',
  });
